module.exports = __webpack_public_path__ + "static/media/memoriesLogo.a717440d.jpg";